import SearchDropdown from "./Search"
(function(){
    const CLASS = "search-form-group"
    document.querySelectorAll(`.${CLASS}`).forEach((s) => s && new SearchDropdown(s))
})()